module.exports = __webpack_public_path__ + "static/media/heart.8739ada0.svg";